import "./index.css";
import { ptBR } from "@material-ui/core/locale";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import "react-phone-input-2/lib/style.css";
import { FilterCheckinProvider } from "context/FilterCheckinContext";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Store, { persistor } from "./store/index";
import "react-toastify/dist/ReactToastify.css";
import "./fonts/Graphik-Regular.ttf";

const theme = createTheme(
  {
    palette: {
      primary: { main: "#000000" },
      secondary: { main: "#2D5BFF" },
      error: { main: "#F43636" },
    },
  },
  ptBR
);

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={Store}>
        <PersistGate persistor={persistor}>
          <ThemeProvider theme={theme}>
            <FilterCheckinProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </FilterCheckinProvider>
          </ThemeProvider>
          <ToastContainer />
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
